import administracao from './administracao'
import autenticacao from './autenticacao'
import cadastro from './cadastro'
import perfil from './perfil'

const baseApiUrl = `/api`

export default {
    administracao: administracao(baseApiUrl),
    autenticacao: autenticacao(baseApiUrl),
    cadastro: cadastro(baseApiUrl),
    perfil: perfil(baseApiUrl),
}